'use client';

import Sentry from '@/components/Sentry';
import {
  Box,
  Flex,
  VStack,
  extendTheme,
} from '@medsimples/design-system/src/chakra';
import AntecipameLogo from '@public/icons/logo/antecipame-logo.svg';
import Logo from '@public/icons/logo/logo.png';
import SeuLogo from '@public/icons/logo/seu-logo.png';
import { Poppins } from 'next/font/google';
import Image from 'next/image';
import type { ReactNode } from 'react';
import { useTenantConfig } from './providers/tenant_provider';
import { ProvidersClient } from './providers_client';

const poppins = Poppins({
  weight: ['400', '500', '600'],
  subsets: ['latin'],
});

export default function RootLayoutClient({
  children,
  theme,
  idToken,
}: {
  children: ReactNode;
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  theme: any;
  idToken: string;
}) {
  const extendedTheme = extendTheme({ theme });
  const { logo, appname } = useTenantConfig();

  const appLogo = (() => {
    switch (logo) {
      case 'antecipame-logo':
        return AntecipameLogo;
      case 'agencia':
        return SeuLogo;
      default:
        return Logo;
    }
  })();

  return (
    <html lang='pt-BR' suppressHydrationWarning>
      <title>{appname}</title>
      <link rel='icon' type='image/png' href={appLogo.src} />
      <body>
        <ProvidersClient theme={extendedTheme}>
          <main className={poppins.className}>
            <Flex
              h='100vh'
              flexDirection='column'
              justifyContent='start'
              alignItems='center'
            >
              <VStack maxW='400px' paddingY={9} paddingX={7} spacing={10}>
                <Box>
                  <Image
                    style={{ maxWidth: '250px' }}
                    data-testid='logo'
                    src={appLogo}
                    alt='logo'
                  />
                </Box>
                {children}
              </VStack>
            </Flex>
            <Sentry idToken={idToken} />
          </main>
        </ProvidersClient>
      </body>
    </html>
  );
}
